import _ from 'underscore';
import React, { useContext } from 'react';

export const InstrumentationServiceContext = React.createContext({
  logError: _.noop,
  logTrace: _.noop,
  logMetrics: _.noop,
  instrumentation: {},
});

export const useInstrumentationServiceContext = () => {
  const context = useContext(InstrumentationServiceContext);
  return context;
};
